export const IconChangeStatus: {
  name: 'icon_change_status-f270d8594ea1'
} = {
  name: 'icon_change_status-f270d8594ea1'
}
